import { Fragment, useState, useEffect } from 'react';

import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';

import { InvoiceService } from '../../service/InvoiceService';

import { HoaDon } from './HoaDon';
import { ChungTu } from './ChungTu';

const invoiceService = new InvoiceService();

const products = [
	{
		type: 'invoice',
		title: 'Hóa đơn điện tử',
		brand: 'IAM INVOICE',
		description: 'Tạo lập, phát hành, quản lý và tra cứu hóa đơn điện tử theo quy định.',
		url: 'https://skit.iamsoftware.com.vn/products/product-detail.html?slug=iam-invoice&ref=vi-ctv-01&product=iam-invoice&utm_source=mega-menu'
	},
	{
		type: 'pit',
		title: 'Chứng từ khấu trừ thuế TNCN',
		brand: 'IAM PIT',
		description: 'Phát hành, gửi email và tra cứu chứng từ khấu trừ thuế TNCN điện tử.',
		url: 'https://skit.iamsoftware.com.vn/products/product-detail.html?slug=iam-pit&ref=vi-ctv-01&product=iam-pit&utm_source=mega-menu'
	},
	{
		type: 'contract',
		title: 'Hợp đồng điện tử',
		brand: 'IAM eContract',
		description: 'Ký kết, quản lý, lưu trữ và tra cứu hợp đồng điện tử an toàn.',
		url: 'https://skit.iamsoftware.com.vn/products/product-detail.html?slug=iam-econtract&ref=vi-ctv-01&product=iam-econtract&utm_source=mega-menu'
	},
	{
		type: 'pos',
		title: 'Quản lý bán hàng',
		brand: 'IAM POS',
		description: 'Quản lý bán hàng, đơn hàng, kho, doanh thu và kết nối hóa đơn điện tử.',
		url: 'https://skit.iamsoftware.com.vn/products/product-detail.html?slug=iam-pos&ref=vi-ctv-01&product=iam-pos&utm_source=mega-menu'
	},
	{
		type: 'task',
		title: 'Quản lý công việc',
		brand: 'IAM TASK',
		description: 'Quản lý công việc, dự án và nâng cao hiệu suất làm việc nhóm.',
		url: 'https://skit.iamsoftware.com.vn/products/product-detail.html?slug=iam-task&ref=vi-ctv-01&product=iam-task&utm_source=mega-menu'
	}
];

const ProductSvg = ({ type }) => {
	if (type === 'invoice') {
		return <img src="/assets/images/invoice.png" alt="IAM Invoice" style={{ objectFit: 'contain' }} />;
	}
	if (type === 'pit') {
		return <img src="/assets/images/pit.png" alt="IAM PIT" style={{ objectFit: 'contain' }} />;
	}
	if (type === 'contract') {
		return <img src="/assets/images/econtract.png" alt="IAM eContract" style={{ objectFit: 'contain' }} />;
	}
	if (type === 'pos') {
		return <img src="/assets/images/pos.png" alt="IAM POS" style={{ objectFit: 'contain' }} />;
	}
	return <img src="/assets/images/task.png" alt="IAM TASK" style={{ objectFit: 'contain' }} />;
};

const benefits = [
	{
		type: 'shield',
		title: 'Tuân thủ pháp lý',
		description: 'Đáp ứng đầy đủ quy định về hóa đơn, chứng từ, thuế.'
	},
	{
		type: 'clock',
		title: 'Tiết kiệm thời gian',
		description: 'Tự động hóa quy trình, tra cứu nhanh chóng.'
	},
	{
		type: 'lock',
		title: 'An toàn bảo mật',
		description: 'Công nghệ bảo mật tiên tiến, dữ liệu được mã hóa.'
	},
	{
		type: 'cost',
		title: 'Tối ưu chi phí',
		description: 'Giảm chi phí vận hành, nâng cao hiệu quả quản lý.'
	}
];

const BenefitSvg = ({ type }) => {
	if (type === 'shield') {
		return <img src="/assets/images/benefit_1.png" alt="Tuân thủ pháp lý" style={{ objectFit: 'contain' }} />;
	}
	if (type === 'clock') {
		return <img src="/assets/images/benefit_2.png" alt="Tiết kiệm thời gian" style={{ objectFit: 'contain' }} />;
	}
	if (type === 'lock') {
		return <img src="/assets/images/benefit_3.png" alt="An toàn bảo mật" style={{ objectFit: 'contain' }} />;
	}
	return <img src="/assets/images/benefit_4.png" alt="Tối ưu chi phí" style={{ objectFit: 'contain' }} />;
};

export const TraCuu = () => {

	const [value, setValue] = useState('');
	const [referenceNumber, setReferenceNumber] = useState('');
	const [message, setMessage] = useState(null);
	const [headerInfo, setHeaderInfo] = useState({});
	const [display, setDisplay] = useState(0);
	const [mode, setMode] = useState('HOA_DON');

	const lockup = (searchValue) => {
		const searchVal = (typeof searchValue === 'string') ? searchValue : value;
		if (searchVal) {
			invoiceService.getHeaderInfo(searchVal).then((data) => {
				if (data['invoiceTotal'] && data['currencyUomId']) {
					data['invoiceTotalLocaleString'] = data['invoiceTotal'].toLocaleString('vi-VN', { style: 'currency', currency: data['currencyUomId'] });
				}
				setHeaderInfo(data);
				setReferenceNumber(searchVal);
				setMode('HOA_DON');
				setMessage(null);
				setDisplay(Date.now());
			}).catch((err) => {
				const response = err.response;
				if (response && response.status === 400) {
					// Check for Tax Certificate before showing error
					invoiceService.getTaxCertificate(searchVal).then(() => {
						setReferenceNumber(searchVal);
						setMode('CHUNG_TU');
						setMessage(null);
						setDisplay(Date.now());
					}).catch((err2) => {
						const response2 = err2.response;
						if (response2 && response2.status === 400) {
							// Real 400 error for certificate as well
							setMessage(`Không tìm thấy hóa đơn, chứng từ có mã tra cứu: ${searchVal}`);
						} else {
							// For other errors (like CORS "red 200"), try showing the dialog anyway
							// as the iframe may still successfully load the document cross-origin
							setReferenceNumber(searchVal);
							setMode('CHUNG_TU');
							setMessage(null);
							setDisplay(Date.now());
						}
					});
				} else {
					setMessage('Có lỗi xảy ra...');
				}
			});
		}
		setDisplay(Date.now());

	}

	useEffect(() => {
		const searchParams = new URLSearchParams(window.location.search || window.location.hash.split('?')[1]);
		const ref = searchParams.get('referenceNumber');
		if (ref) {
			setValue(ref);
			lockup(ref);
		}
	}, []);

	return (
		<Fragment>
			{mode === 'HOA_DON' && <HoaDon referenceNumber={referenceNumber} display={display} setDisplay={setDisplay} headerInfo={headerInfo} />}
			{mode === 'CHUNG_TU' && <ChungTu referenceNumber={referenceNumber} display={display} setDisplay={setDisplay} />}
			<main className="lookup-page">
				<section className="layout-tra-cuu lookup-hero">
					<div className="lookup-container lookup-hero-inner">
						<div className="lookup-hero-content">
							<p className="lookup-eyebrow">TRA CỨU HÓA ĐƠN ĐIỆN TỬ, CHỨNG TỪ THUẾ TNCN</p>
							<div className="lookup-search-panel">
								<div className="lookup-search-row">
									<InputText value={value} onChange={(e) => setValue(e.target.value)} placeholder="Nhập mã tra cứu..." />
									<Button label="Tra cứu" icon="pi pi-search" onClick={lockup} />
								</div>
								{message && (
									<div className="p-message p-component p-message-error p-message-enter-done lookup-message">
										<div className="p-message-wrapper">
											<span className="p-message-icon pi pi-times-circle" />
											<span className="p-message-detail">{message}</span>
										</div>
									</div>
								)}
							</div>

						</div>
					</div>
				</section>

				<section className="ecosystem-section">
					<div className="lookup-container">
						<div className="section-heading">
							<span />
							<h2>HỆ SINH THÁI SẢN PHẨM IAM</h2>
							<span />
						</div>
						<div className="product-grid">
							{products.map((product) => (
								<a href={product.url} target="_blank" rel="noreferrer" className="product-card" key={product.brand}>
									<div className="product-icon"><ProductSvg type={product.type} /></div>
									<h3>{product.title}</h3>
									<strong>{product.brand}</strong>
									<p>{product.description}</p>
								</a>
							))}
						</div>
						<div className="ecosystem-action">
							<a href="https://skit.iamsoftware.com.vn/" target="_blank" rel="noreferrer">Tìm hiểu thêm <i className="pi pi-arrow-right" /></a>
						</div>
					</div>
				</section>

				<section className="layout-loi-ich benefits-section">
					<div className="lookup-container benefits-panel">
						<h2>LỢI ÍCH KHI SỬ DỤNG HỆ SINH THÁI IAM</h2>
						<div className="benefit-grid">
							{benefits.map((benefit) => (
								<div className="benefit-item" key={benefit.title}>
									<div className="benefit-icon"><BenefitSvg type={benefit.type} /></div>
									<div>
										<h3>{benefit.title}</h3>
										<p>{benefit.description}</p>
									</div>
								</div>
							))}
						</div>
					</div>
				</section>
			</main>
		</Fragment>
	);
}
